function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXls = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 36"
}, props), /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "gray",
    fillOpacity: 1
  },
  d: "M.879 0A.88.88 0 0 0 0 .879V31.8c0 .484.395.875.879.875h24.715c.484 0 .879-.39.879-.875V10.609a2.458 2.458 0 0 0-.621-1.5L17.359.621A2.404 2.404 0 0 0 15.86 0Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  },
  d: "M1.605.586c-.48 0-.875.39-.875.875v30.047c0 .484.395.875.875.879H25.31a.882.882 0 0 0 .875-.88V10.755a2.413 2.413 0 0 0-.622-1.5l-8.054-8.05a2.44 2.44 0 0 0-1.5-.618Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#eaecef",
    fillOpacity: 1
  },
  d: "M17.355 2.906V7.29c0 .922.75 1.672 1.672 1.672h4.555Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#e6e7e8",
    fillOpacity: 1
  },
  d: "m17.012 8.32-.403-7.21-.617 8.234c0 .484.39.875.875.875h7.98l-6.956-1.024a.877.877 0 0 1-.88-.875Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#11437a",
    fillOpacity: 1
  },
  d: "M26.18 23.488a.778.778 0 0 1-.785.762H1.515a.778.778 0 0 1-.785-.762v-8.902a.778.778 0 0 1 .786-.762h23.879a.778.778 0 0 1 .785.762Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#1f59a2",
    fillOpacity: 1
  },
  d: "M26.18 23.934a.778.778 0 0 1-.785.761H1.515a.778.778 0 0 1-.785-.761V15.03a.775.775 0 0 1 .786-.761h23.879a.775.775 0 0 1 .785.761Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1,
    strokeWidth: 0.31,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#fff",
    strokeOpacity: 1,
    strokeMiterlimit: 10
  },
  d: "m18.055 58.147 2.152-3.257-2.043-3.23h1.09l1.555 2.44 1.636-2.44h.868l-2.07 3.128 2.12 3.36h-1.085l-1.649-2.575-1.703 2.574Zm0 0",
  transform: "translate(-12.465 -35.663)"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1,
    strokeWidth: 0.31,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#fff",
    strokeOpacity: 1,
    strokeMiterlimit: 10
  },
  d: "M38.652 58.147V51.66h.918v5.8h2.922v.688Zm0 0",
  transform: "translate(-26.683 -35.663)"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1,
    strokeWidth: 0.31,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#fff",
    strokeOpacity: 1,
    strokeMiterlimit: 10
  },
  d: "M52.814 57.658v-.91a4.484 4.484 0 0 0 1.805.512c.313.016.625-.086.867-.285a.955.955 0 0 0 .332-.75.981.981 0 0 0-.218-.649c-.227-.246-.5-.449-.797-.601l-.45-.258a4.193 4.193 0 0 1-1.164-.895 1.49 1.49 0 0 1-.34-.968 1.59 1.59 0 0 1 .544-1.239 1.988 1.988 0 0 1 1.382-.484c.536.004 1.067.09 1.579.246v.844c-.485-.219-1-.356-1.528-.402a1.21 1.21 0 0 0-.785.257.794.794 0 0 0-.312.641c0 .21.082.418.226.574.25.238.527.442.832.602l.465.261c.441.227.84.532 1.172.899.226.293.344.652.332 1.023.02.524-.211 1.028-.621 1.36-.473.36-1.059.539-1.653.511a6.522 6.522 0 0 1-1.668-.289Zm0 0",
  transform: "translate(-36.459 -35.299)"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fillRule: "nonzero",
    fill: "#1f59a2",
    fillOpacity: 1,
    strokeWidth: 1.858,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#fff",
    strokeOpacity: 1,
    strokeMiterlimit: 10
  },
  d: "M35.618 87.914v-3.872h-4.027v3.872H29.47l4.11 5.101 4.109-5.101Zm0 0",
  transform: "translate(-20.345 -58.019)"
}));
export default SvgXls;